import { render, staticRenderFns } from "./IconSvgNCIAConnect.vue?vue&type=template&id=64bb063b&scoped=true&"
import script from "./IconSvgNCIAConnect.vue?vue&type=script&lang=js&"
export * from "./IconSvgNCIAConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb063b",
  null
  
)

export default component.exports